import { css } from '@emotion/css';

import { AlignItems, Color, Display, Font, JustifyContent, ScreenBreakpoint, Spacing } from '../../../styles';

export const blurSection = css`
  pointer-events: none;
  -webkit-filter: blur(8px);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
`;

export const alert = css`
  color: ${Color.Brand6};
`;

export const buttonContainer = css`
  ${Spacing.mt16}
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
`;

export const mobileActionButton = css`
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    &.ant-btn {
      ${Spacing.px24}
    }
  }
`;

export const timelineIcon = css`
  ${Font.h6}
  ${Spacing.ml4}
  position: absolute;
`;
